module.exports = __webpack_public_path__ + "img/arrow-clockwise.cd2db90a.svg";